import { useEffect, useState } from 'react';
import { AirportView } from './AirportView';
import { Routes } from './Routes/Routes';
import { DATA } from '../../game/data';
import { observer } from 'mobx-react-lite';
import { IMAGES } from '../../game/data/images';
import { COLORS } from '../../game/data/colors';
import { MainUI } from '../UI/MainUI';
import { ZOOM_FACTOR, ZOOM_WIDTH } from '../..';

export const SIDEBAR_WIDTH = 350;

export const WorldMap: React.FC = observer(() => {
  const [dimensions, setDimensions] = useState({ width: '100vw', height: '66vw' });
  useEffect(() => {
    const updateDimensions = () => {
      const aspectRatio = 2 / 3; // Aspect ratio based on the original dimensions
      let windowWidth = window.innerWidth - SIDEBAR_WIDTH;
      let windowHeight = window.innerHeight;
      if (window.innerWidth < ZOOM_WIDTH) {
        windowWidth /= ZOOM_FACTOR - 0.1;
        windowHeight /= ZOOM_FACTOR - 0.1;
      }

      let width, height;

      if (windowWidth / windowHeight > 3 / 2) {
        height = windowHeight;
        width = windowHeight * (3 / 2);
      } else {
        width = windowWidth;
        height = windowWidth * aspectRatio;
      }

      setDimensions({ width: `${width}px`, height: `${height}px` });
    };

    updateDimensions();
    window.addEventListener('resize', updateDimensions);

    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        right: SIDEBAR_WIDTH,
        backgroundColor: COLORS.zinc_900,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          width: dimensions.width,
          height: dimensions.height,
          position: 'relative',
        }}
      >
        <div style={{ position: 'absolute', inset: 0, backgroundImage: `url(${IMAGES.map})`, backgroundSize: 'cover' }}></div>
        <Routes />
        {DATA.airports.map((airport) => (
          <AirportView key={airport.slug} airport={airport} />
        ))}
      </div>
      <MainUI />
    </div>
  );
});
